import React, { useState, useEffect, useRef } from 'react'
import i18n from 'i18n-js'
import { ThemeProvider } from '@material-ui/styles';
import themeViewnia from "components/utils/Theme";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Product from "components/products/Product";
import Skeleton from '@material-ui/lab/Skeleton';
import {mkt_money} from "components/utils/Money.jsx";
import { fetchWithLocale } from "components/utils/Api.jsx";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-W6W9H6NJ'
}
TagManager.initialize(tagManagerArgs)

const useStyles = makeStyles((theme) => ({
  // Estilos para la sección de resultados
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    '& h2': {
      margin: 0,
      fontSize: '1.5rem',
      fontWeight: 700,
    },
    '& .MuiSkeleton-root': {
      margin: 0,
    },
  },
}));

function Products(props) {
  const pageRef = useRef(1); 
  const newPage = useRef(1); 
  const [products, setProducts] = useState([]);
  const [optional_products, setOptionalProducts] = useState([]);
  const [optinal_results_text, setOptinalResultsText] = useState("");
  const [optinal_results, setOptinalResults] = useState(false);
  
  const [activities, setActivities] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPageloading, setIsPageloading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  
  const [activityValue, setActivityValue] = useState("");
  const [regionValue, setRegionValue] = useState("");
  const [timeValue, setTimeValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [dateValueForSelect, setDateValueForSelect] = useState("");
  const [isSearch, setIsSearch] = useState(false)
  const [activityObject, setActivityObject] = useState("");
  const [regionObject, setRegionObject] = useState("");
  
  const [stringSearch, setStringSearch] = useState("");
  const [titleSearch, setTitleSearch] = useState("");
  const [descriptionCategory, setDescriptionCategory] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setDateValue(date);
    setDateValueForSelect("current_date");
  };

  const [initialTitle, setInitialTitle] = useState(i18n.t("products_search.all_adventures"));
  const [loadingTitle, setLoadingTitle] = useState(true);
  
  const classes = useStyles();
  let guide_image = "https://viewnia-static.s3.us-east-2.amazonaws.com/especialista.png";

  // Mapeo de valores de tiempo
  const timeOptions = [
    { value: "half_day", label: i18n.t("excursions.half_day") },
    { value: "full_day", label: i18n.t("excursions.full_day") },
    { value: "multiple_days", label: i18n.t("excursions.multiple_days") }
  ];

  // Función para manejar búsquedas desde el header
  const handleSearchFromHeader = (activity, region, time) => {
    setActivityValue(activity || "");
    setRegionValue(region || "");
    setTimeValue(time || "");
    setIsSearch(true);
    search(activity, region, time);
  };

  // Toda la lógica original preservada
  useEffect(() => {
    console.log("Component mounted, loading initial data...");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let activity = ""
    let region = ""
    let time = ""
    let date = ""
    
    if (urlParams.has('activity')){
      activity = (urlParams.get('activity'))
      setActivityValue(urlParams.get('activity'))
    }
    if(props.activity){
      activity = props.activity
      setActivityValue(props.activity)
    }
    if (urlParams.has('region')){
      region = (urlParams.get('region'))
      setRegionValue(urlParams.get('region'))
    }
    if (urlParams.has('time')){
      time = (urlParams.get('time'))
      setTimeValue(urlParams.get('time'))
    }
    if (urlParams.has('date')){
      date = (new Date(Date.parse(urlParams.get('date'))))
      setDateValue(date)
      setSelectedDate(date);
      setDateValueForSelect("current_date")
    }

    setTimeout(() => {
      if ((urlParams.has('activity') && isNaN(urlParams.get('activity'))) || 
          props.activity || 
          (urlParams.has('region') && isNaN(urlParams.get('region'))) || 
          urlParams.has('time') || 
          urlParams.has('date')) {
        let titleParts = [];
        if (urlParams.has('activity') && isNaN(urlParams.get('activity'))) {
          titleParts.push(props.activity || urlParams.get('activity'));
        }
        if (urlParams.has('region') && isNaN(urlParams.get('region'))) {
          titleParts.push(urlParams.get('region'));
        }
        if (urlParams.has('time')) {
          titleParts.push(i18n.t("excursions." + urlParams.get('time')));
        }
        if (urlParams.has('date')) {
          titleParts.push(new Date(Date.parse(urlParams.get('date'))).toLocaleDateString());
        }
        if (titleParts.length > 0) {
          setInitialTitle(titleParts.join(" " + i18n.t("products_search.in") + " "));
        }
      }
      setLoadingTitle(false);
    }, 1000);

    get_products(activity, region, time, date);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if ((window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 200) && !isPageloading ) {
        if (!isPageloading && hasMore) {
          if (pageRef.current !== newPage.current + 1) {
            pageRef.current = newPage.current + 1;
            get_products(activityValue, regionValue, timeValue, dateValue, true);
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isPageloading]);

  useEffect(() => {
    if(activityValue){
      setActivityObject(activities.find(activity => activity.id ==  activityValue))
    }
    if(regionValue){
      setRegionObject(regions.find(region => region.id ==  regionValue))
    }
  }, [activityValue, regionValue]);

  function search(activityVal = activityValue, regionVal = regionValue, timeVal = timeValue){
    console.log("Search function called");
    setIsSearch(true)
    newPage.current = 1
    pageRef.current = 1
    get_products(activityVal, regionVal, timeVal, dateValue);
  }

  useEffect(() => {
    if(isSearch){
      get_products(activityValue, regionValue, timeValue, dateValue);
    }
  }, [isSearch]);

  function get_products(activityValue_t = null, regionValue_t = null, timeValue_t= null, dateValue_t= null, isNewPage = false){
    console.log("Getting products...", { activityValue_t, regionValue_t, timeValue_t, dateValue_t, isNewPage });
    (!isNewPage && setLoading(true) || setIsPageloading(true))
    const nextPage = (isNewPage ? newPage.current + 1 : 1)

    return fetchWithLocale(`/get_products.json?activity=${activityValue_t}&region=${regionValue_t}&time=${timeValue_t}&date=${dateValue_t}&page=${nextPage}`)
      .then(response => response.json())
      .then(json => {
        console.log("Products received:", json);
        let updatedProducts = isNewPage ? [...products, ...json.excursions] : json.excursions;
        let uniqueProducts = Array.from(new Map(updatedProducts.map(p => [p.id, p])).values());
        setProducts(uniqueProducts); 
        createDataLayer(uniqueProducts);
        setActivities(json.activities)
        setRegions(json.regions)
        setLoading(false)
        setIsPageloading(false)
        if (isNewPage) {
          setPage(nextPage);
          newPage.current = nextPage
        } else {
          setPage(1);
          newPage.current = 1
        }
        setHasMore(json.has_more)
        let activitiesObj = {}
        let regionsObj = {}
        
        if(activityValue_t){
          activitiesObj = (json.activities.find(activity => activity.id ==  activityValue_t))
        }
        if(regionValue_t){
          regionsObj = (json.regions.find(region => region.id ==  regionValue_t))
        }

        if(uniqueProducts.length > 0){
          setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
          setStringSearch([(activitiesObj ? activitiesObj.name : ""), (regionsObj ? regionsObj.name : ""), (timeValue_t ? i18n.t("excursions." + timeValue_t) : ""), (dateValue_t ? dateValue_t.toLocaleDateString() : "")].filter(Boolean).join(", "))
        }else{
          if(regionsObj.name  && activitiesObj.name ){
            setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
            setStringSearch(i18n.t('searches.category_products_in_zone_no_result', {category_name: (activitiesObj ? activitiesObj.name : ""), zone_name: (regionsObj ? regionsObj.name : "")}))
          }else if(regionsObj.name ){
            setStringSearch(i18n.t('searches.all_products_in_zone_no_result', {zone_name: (regionsObj ? regionsObj.name : "")}))
          }else if(activitiesObj.name ){
            setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
            setStringSearch(i18n.t('searches.all_category_products_no_result', {category_name: (activitiesObj ? activitiesObj.name : "")}))
          }
        }
        setTitleSearch([(activitiesObj ? activitiesObj.name : ""), (regionsObj ? regionsObj.name : ""), (timeValue_t ? i18n.t("excursions." + timeValue_t) : ""), (dateValue_t ? dateValue_t.toLocaleDateString() : "")].filter(Boolean).join(" " + i18n.t("products_search.in") + " "));

        if(json.no_results_found){     
          if(json.optinal_results_text == "activity"){
            setOptinalResultsText((activityObject ? activityObject.name : ""))
          }
          else if(json.optinal_results_text == "region"){
            setOptinalResultsText((regionObject ? regionObject.name : ""))
          }
          else if(json.optinal_results_text == "time"){
            setOptinalResultsText((timeValue ? i18n.t("excursions." + timeValue) : ""))
          }else{
            setOptinalResultsText("")
          }
          setOptinalResults(json.no_results_found)
          setOptionalProducts(json.optinal_results)
        }
      })
      .catch(error => {
        console.error("Error fetching products:", error);
        setLoading(false);
        setIsPageloading(false);
      });
  }

  function createDataLayer(excursions){
    window.dataLayer.push({ ecommerce: null }); 
    var new_products = []; 
    excursions && excursions.map((product) => {
      new_products.push(
        {
          'item_id': product.id,
          'item_name': product.title,
          'price': mkt_money(product),
          'item_brand': (product.agency ? product.agency?.name : "Outdoor Index"),
          'item_category': (product.zone && product.zone.name || ""),
          'item_variant': 'Excursion',
          'affiliation': 'Outdoor index',
          'quantity': '1'
        }
      )
    })
    window.dataLayer.push({
      'event': "view_item_list",
      'ecommerce': {
        'item_list_id': "products_list",
        'item_list_name': "Products List",
        'items': new_products
       }
    });
  }

  console.log("Rendering component, loading:", loading, "products:", products.length);

  return (
    <ThemeProvider theme={themeViewnia}>
      <section className="home-section">
        <section className="head-text">
          {loadingTitle || loading ? (
            <>
              <Skeleton 
                variant="text" 
                width="40%" 
                height={60} 
                className="skeleton-title"
                animation="wave"
                style={{ 
                  fontSize: '2.5rem',
                  lineHeight: '1.2',
                  transform: 'none',
                  margin: '0 auto',
                  marginBottom: '1.5rem',
                  textAlign: 'center',
                }} 
              />
              <Skeleton 
                variant="text" 
                width="50%" 
                height={42} 
                className="skeleton-description"
                animation="wave"
                style={{ 
                  fontSize: '1.1rem',
                  lineHeight: '1.5',
                  transform: 'none',
                  margin: '0 auto',
                  marginBottom: '3em',
                  textAlign: 'center',
                }} 
              />
            </>
          ) : (
            <>
              <div class="head-text-info">
                <h1 class="head-text-title"><strong>{titleSearch || initialTitle}</strong></h1>
                <div class="head-text-subtitle"><p>{descriptionCategory || i18n.t("products_search.subtext")}</p></div>
              </div>

              <div className="chat-widget">
                <div className="chat-avatar">
                  <img src={guide_image} alt="Especialista" />
                </div>
                <div className="chat-content">
                  <p className="chat-question">{i18n.t('chat.need_help')}</p>
                  <a
                    href="https://api.whatsapp.com/send?phone=56981785011"
                    className="chat-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="chat-answer">
                      {i18n.t('chat.talk_to_local_guide')}
                    </p>
                  </a>
                </div>
              </div>
            </>
          )}
        </section>

        {/* Home products section */}
        {(props.home_products && !isSearch) && 
          <>
            <br /><br />
            <header><h2>{props.home_title}</h2></header>
              <Grid container spacing={2}>
                {props.home_products && props.home_products.map((product) => {
                    const labelId = `products-label-${product.id}`;
                    return (
                      <Grid item xs={12} sm={6} md={3} key={labelId}>
                        <Product
                          product={product}
                          image_format={"large"}
                        />
                      </Grid>
                    );
                })}
              </Grid>      
          </>
        }

        {/* Products section */}
        <section className="products-section">
          <Grid container 
                direction="row"
                justify="space-between"
                alignItems="center" 
                spacing={2}>
            <Grid item xs={12} sm={8} className={classes.titleContainer}>
              {loading ? (
                <Skeleton 
                  variant="text"
                  width="60%"
                  height={32}
                  animation="wave"
                />
              ) : (
                <h2>
                  {stringSearch ? 
                    <>{stringSearch} ({products.length})</> :
                    <>{i18n.t("products_search.all_adventures")} ({products.length})</>
                  }
                </h2>
              )}
            </Grid>
          </Grid>

          {loading ? (
            <Grid container spacing={2}>
              {Array.from(new Array(8)).map((item, index) => (
                <Grid key={"skeleton" + index} item xs={12} sm={6} md={3} className='posts'>
                  <Skeleton variant="rect" className="lazyload" height={(394)} animation="wave" style={{ borderRadius: "15px" }} />
                  <Skeleton variant="rect" className="lazyload info-slide product-skeleton-line" height={10} animation="wave" />
                  <Skeleton variant="rect" className="lazyload product-skeleton-line" height={10} animation="wave" />
                  <Skeleton variant="rect" className="lazyload product-skeleton-line" height={10} animation="wave" />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {products && products.map((product) => {
                  let labelId = `products-label-${product.id}`;
                  return (
                    <Grid item xs={12} sm={6} md={3} key={labelId}>
                      <Product
                        product={product}
                        image_format={"large"}
                      />
                    </Grid>
                  );
              })}
            </Grid>
          )}

          {isPageloading && hasMore && (
            <div style={{ textAlign: "center", margin: "20px" }}>
              <CircularProgress />
            </div>
          )}
        </section>

        {/* Optional products section */}
        {!loading && optional_products.length > 0 &&
          <section className="products-section">
            <Grid container direction="row"
                  justify="space-between"
                  alignItems="center" 
                  spacing={2}>
                <Grid item xs={12} sm={8}>  
                  <h2>
                    {optinal_results_text ? 
                      <>{optinal_results_text} ({optional_products.length})</> :
                      <>{i18n.t("products_search.all_adventures")} ({optional_products.length})</>
                    }
                  </h2>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
              {optional_products && optional_products.map((product) => {
                  let labelId = `products-label-${product.id}`;
                  return (
                    <Grid item xs={12} sm={6} md={3} key={labelId}>
                      <Product
                        product={product}
                        image_format={"large"}
                      />
                    </Grid>
                  );
              })}
            </Grid>
          </section>
        } 
      </section>
    </ThemeProvider>
  );
}

// Exponer la función handleSearchFromHeader para que el header pueda usarla
Products.handleSearchFromHeader = function(activity, region, time) {
  // Esta función será llamada desde el header
  console.log("Search triggered from header:", { activity, region, time });
};

export default Products;